import React from 'react';
import GlobalSearchDialog from 'src/components/common/GlobalSearchDialog';

export type dialogCreator = {
    searchDialog: () => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        searchDialog: () => {
            setDialog(React.createElement(GlobalSearchDialog));
        },
    };
};

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/nav.ts